import * as React from "react";
import { useMemo } from "react";
import styled, { css } from "styled-components";
import DOMPurify from "dompurify";
import LoginBox from "components/login/LoginBox";
import PublicNotifications from "components/common/PublicNotifications";
import backgroundImage from "images/auth/login-bg.svg";
import { Logo } from "components/navigation/NavigationBrand";
import AppConfig from "util/AppConfig";
import useThemes from "theme/hooks/useThemes";
import useCustomLogo from "brand-customization/useCustomLogo";
import useProductName from "brand-customization/useProductName";
const LogoContainer = styled.div`
  display: block;
  width: auto;
  margin: auto;

  svg {
    width: 100%;
    min-height: 120px;
    height: 8vh;
  }
`;
const Background = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
`;
const BackgroundText = styled.div(
  ({ $backgroundImage }) => css`
    z-index: -1;
    display: flex;
    flex-direction: column;
    position: absolute;
    vertical-align: middle;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 0 30px;
    background-image: url(${$backgroundImage});
    background-position: center;
    background-size: cover;
  `
);
const NotificationsContainer = styled.div`
  position: absolute;
  top: 0;
  margin-top: 5px;
  width: 100%;
`;
const LoginContainer = styled.div`
  display: flex;
  flex: 1 1 0%;
  flex-direction: row;
  min-width: 100%;
  min-height: 100%;
`;
const TextContainer = styled.div`
  vertical-align: middle;
  justify-content: center;
  place-self: center center;
  height: auto;
`;
const WelcomeMessage = styled.strong(
  ({ theme }) => css`
    display: block;
    font-size: ${theme.fonts.size.extraLarge};
    font-weight: 800;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  `
);
const CustomLogo = styled.div`
  svg {
    width: 100%;
    height: 200px;
  }
`;
const CustomizableLogo = () => {
  const { colorScheme } = useThemes("dark", false);
  const customLogo = useCustomLogo(colorScheme);
  return customLogo ? /* @__PURE__ */ React.createElement(CustomLogo, { dangerouslySetInnerHTML: { __html: customLogo } }) : /* @__PURE__ */ React.createElement(LogoContainer, null, /* @__PURE__ */ React.createElement(Logo, { color: "#03C3FF" }));
};
const sanitize = (content) => DOMPurify.sanitize(content, { USE_PROFILES: { svg: true }, ADD_TAGS: ["use"], ADD_ATTR: ["xlink:href"] });
const svgDataUrl = (content) => `data:image/svg+xml;base64,${Buffer.from(content).toString("base64")}`;
const useLoginBackground = () => useMemo(
  () => {
    var _a, _b, _c, _d;
    return ((_b = (_a = AppConfig.branding()) == null ? void 0 : _a.login) == null ? void 0 : _b.background) ? svgDataUrl(sanitize((_d = (_c = AppConfig.branding()) == null ? void 0 : _c.login) == null ? void 0 : _d.background)) : backgroundImage;
  },
  []
);
const useShowLogo = () => useMemo(() => {
  var _a, _b, _c;
  return (_c = (_b = (_a = AppConfig.branding()) == null ? void 0 : _a.login) == null ? void 0 : _b.show_logo) != null ? _c : true;
}, []);
const LoginChrome = ({ children }) => {
  const productName = useProductName();
  const loginBackground = useLoginBackground();
  const showLogo = useShowLogo();
  return /* @__PURE__ */ React.createElement(LoginContainer, null, /* @__PURE__ */ React.createElement(LoginBox, null, /* @__PURE__ */ React.createElement(WelcomeMessage, null, "Welcome to ", productName), children), /* @__PURE__ */ React.createElement(Background, null, /* @__PURE__ */ React.createElement(NotificationsContainer, null, /* @__PURE__ */ React.createElement(PublicNotifications, { login: true })), /* @__PURE__ */ React.createElement(BackgroundText, { $backgroundImage: loginBackground }, showLogo && /* @__PURE__ */ React.createElement(TextContainer, null, /* @__PURE__ */ React.createElement(CustomizableLogo, null)))));
};
export default LoginChrome;
